import { useEffect } from 'react';

function GoogleTagManager({ gtmId }) {
  useEffect(() => {
    if (!gtmId) return;
    
    // Limpiar cualquier GTM que no sea el deseado
    const allGtmScripts = document.querySelectorAll('script[src*="googletagmanager.com/gtm.js"]');
    allGtmScripts.forEach(script => {
      if (!script.src.includes(gtmId)) {
        script.remove();
      }
    });
    
    const allNoscripts = document.querySelectorAll('noscript iframe[src*="googletagmanager.com/ns.html"]');
    allNoscripts.forEach(iframe => {
      if (!iframe.src.includes(gtmId) && iframe.parentElement) {
        iframe.parentElement.remove();
      }
    });

    // Verificar si ya existe el GTM correcto en el DOM
    const existingScript = document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${gtmId}"]`);
    if (existingScript) {
      return;
    }

    // Inicializar dataLayer si no existe
    window.dataLayer = window.dataLayer || [];

    // Cargar nuevo GTM
    (function(w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', gtmId);

    // Manejar el noscript fallback
    const existingNoscript = document.querySelector(`noscript iframe[src*="googletagmanager.com/ns.html?id=${gtmId}"]`);
    if (!existingNoscript && document.body) {
      const noscript = document.createElement('noscript');
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
      iframe.height = '0';
      iframe.width = '0';
      iframe.style.display = 'none';
      iframe.style.visibility = 'hidden';
      noscript.appendChild(iframe);
      document.body.insertBefore(noscript, document.body.firstChild);
    }
  }, [gtmId]);

  return null;
}

export default GoogleTagManager;
export { GTM_IDS } from './constats';

